import { logService, LocalStorage } from '@Engage.Core';
import { StorageKeys } from '@Engage.Data.Constants';
export class AdBlockDetector {
    constructor() {
        this.localStorage = new LocalStorage();
        this.storedValue = false; // last detection result
        this.firstLoadPromise = null;
    }
    // Singleton
    static getInstance() {
        if (!AdBlockDetector.instance) {
            AdBlockDetector.instance = new AdBlockDetector();
        }
        return AdBlockDetector.instance;
    }
    /**
     * Initializes detection and returns a promise with result
     * @param useLastDetect Use last stored detection value
     */
    async init(useLastDetect = true) {
        try {
            await this.loadDetectionElements();
            return this.detectAdBlock(useLastDetect);
        }
        catch (err) {
            logService.log(AdBlockDetector.NAME, 'init', 'Detection failed, defaulting to true', err);
            return true;
        }
    }
    /**
     * Load detection DOM elements once
     */
    async loadDetectionElements() {
        if (!this.firstLoadPromise) {
            this.firstLoadPromise = Promise.all([
                this.createTestAdElement(),
                this.createTestAdImage(),
                this.createTestAdScript()
            ]).then(() => undefined);
        }
        return this.firstLoadPromise;
    }
    /** Creates a hidden DIV to check ad blockers */
    async createTestAdElement() {
        const div = document.createElement('div');
        div.id = 'TestAdBlock';
        div.className = 'adsbox adBanner ad-zone ad-space ad-unit textads banner-ads banner_ads';
        div.style.cssText = 'position:absolute;bottom:0;z-index:-1;';
        div.innerHTML = '&nbsp;';
        document.body.appendChild(div);
    }
    /** Creates a hidden IMG to check ad blockers */
    async createTestAdImage() {
        return new Promise((resolve) => {
            const img = document.createElement('img');
            img.id = 'TestAdImg';
            img.src = '//paywall-ad-bucket.s3.amazonaws.com/ad_300_250.jpg';
            img.style.cssText = 'position:absolute;top:-1000px;left:-1000px;width:100px;height:100px;';
            img.onload = () => resolve();
            img.onerror = () => resolve(); // ignore errors
            document.body.appendChild(img);
        });
    }
    /** Creates a SCRIPT tag to check ad blockers */
    async createTestAdScript() {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.id = 'TestAdScript';
            script.type = 'text/javascript';
            script.src = '//cdn.pranmcpkx.com/index.js';
            script.onload = () => {
                script.className = 'adstestloaded';
                resolve();
            };
            script.onerror = () => resolve();
            document.head.appendChild(script);
        });
    }
    /**
     * Detects if AdBlock is active
     */
    detectAdBlock(useLastDetect = true) {
        // If we want to use previously stored value
        if (useLastDetect) {
            const lastDetect = this.localStorage.get(StorageKeys.AdblockLastDetect);
            if (lastDetect != null) {
                this.storedValue = !!lastDetect;
                return this.storedValue;
            }
        }
        let adBlockDetected = false;
        // 1. Check hidden div
        const div = document.getElementById('TestAdBlock');
        if (!div || div.offsetHeight === 0)
            adBlockDetected = true;
        // 2. Check hidden image
        const img = document.getElementById('TestAdImg');
        if (!img || img.offsetHeight === 0)
            adBlockDetected = true;
        // 3. Check script
        const script = document.getElementById('TestAdScript');
        if (!script || script.className !== 'adstestloaded')
            adBlockDetected = true;
        // 4. Check for common blocker styles
        if (document.getElementById('stndz-style'))
            adBlockDetected = true;
        // 5. Optional: check adsbygoogle
        try {
            const xhr = new XMLHttpRequest();
            xhr.open('HEAD', 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', false);
            xhr.send();
            if (xhr.status === 0 || xhr.responseURL !== 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js') {
                adBlockDetected = true;
            }
        }
        catch (_a) { }
        this.storedValue = adBlockDetected;
        // Save to localStorage
        this.localStorage.set(StorageKeys.AdblockLastDetect, adBlockDetected);
        logService.log(AdBlockDetector.NAME, 'detectAdBlock', 'Detected:', adBlockDetected);
        return adBlockDetected;
    }
    /**
     * Remove test DOM nodes
     */
    removeTestNodes() {
        ['TestAdBlock', 'TestAdImg', 'TestAdScript'].forEach((id) => {
            const node = document.getElementById(id);
            if (node && node.parentNode)
                node.parentNode.removeChild(node);
        });
    }
}
AdBlockDetector.NAME = 'AdBlockDetector';
